import React from 'react';
import ReactDOM from 'react-dom';
import './custom.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { EmitFlags } from 'typescript';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
